/**
 *
 * accordian for three column layouts on mobile
 *
 */

(function($) {
	$(document).ready(function() {

		//if ($(window).width() <= 1023) {
			$('.accordion').first().find('div').first().css('display', 'block');
			$('.accordion').first().find('section:first-of-type').addClass('active');

			// Get all the links.
			var link = $('.accordion a');

			// On clicking of the links do something.
			link.on('click', function(e) {

	            $('section.active').removeClass('active').find('.accordion-section-content').slideUp('slow');
	            $(this).closest('section').addClass('active').find('.accordion-section-content').slideDown();
	            console.log($(this).closest('section'))
			    
			});
		//}
		
	}); // document.ready
})(jQuery);
